import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { login, getNetworkType } from '../../api/auth';
import { useAuth } from '../../utils/auth';

const AdminLogin = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const networkType = getNetworkType();
      const response = await login(values.employee_id, values.password, networkType);
      
      if (response.code === 200) {
        // 检查是否为管理员
        if (response.data.user.role !== 'admin') {
          message.error('您不是管理员,无法登录管理后台');
          return;
        }
        
        message.success('登录成功');
        authLogin(response.data.token, response.data.user);
        navigate('/admin/dashboard');
      }
    } catch (error) {
      message.error(error.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <Card 
        style={{ 
          width: 400, 
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          borderRadius: '8px'
        }}
        title={
          <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>
            管理后台登录
          </div>
        }
      >
        <div style={{ marginBottom: '16px', textAlign: 'center', color: '#666' }}>
         "华工图像六项行为准则"学习平台
        </div>
        
        <Form
          name="admin-login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="employee_id"
            rules={[{ required: true, message: '请输入工号' }]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="工号" 
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading}
              block
              style={{ height: '45px' }}
            >
              登录
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: '16px' }}>
          <a href="/" style={{ color: '#666' }}>
            返回员工端登录
          </a>
        </div>
      </Card>
    </div>
  );
};

export default AdminLogin;
